(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pti-gangsheet-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pti-gangsheet-tutorial')) {
    customElements.define('pti-gangsheet-tutorial', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function' || this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.addEventListener('click', event => {
          if (event.target.closest('[data-pti-open]')) { event.preventDefault(); this.open(event.target.closest('[data-pti-open]')); }
          if (event.target.closest('[data-pti-close]')) this.dialog.close();
        }, options);
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-pti-tutorial-trigger]');
          if (trigger && document.querySelector('pti-gangsheet-tutorial') === this) { event.preventDefault(); this.open(trigger); }
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.querySelector('video')?.pause();
          document.documentElement.style.overflow = this.previousOverflow ?? '';
          this.opener?.focus({ preventScroll: true });
        }, options);
      }
      open(opener) {
        if (this.dialog.open) return;
        this.opener = opener;
        const mobileTemplate = this.querySelector('[data-pti-mobile-video]');
        const usePortrait = mobileTemplate && window.matchMedia('(max-width: 749px), (max-height: 600px) and (pointer: coarse)').matches;
        const format = usePortrait ? 'portrait' : 'landscape';
        if (!this.querySelector('video') || this.format !== format) {
          const previous = this.querySelector('video');
          const resumeAt = previous && !previous.ended ? previous.currentTime : 0;
          previous?.pause();
          const template = usePortrait ? mobileTemplate : this.querySelector('[data-pti-desktop-video]');
          this.querySelector('.pti-tutorial__player').replaceChildren(template.content.cloneNode(true));
          this.format = format;
          this.dialog.dataset.format = format;
          if (resumeAt > 0) this.querySelector('video').addEventListener('loadedmetadata', event => {
            event.target.currentTime = Math.min(resumeAt, event.target.duration || 0);
          }, { once: true });
        }
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        const video = this.querySelector('video');
        if (video.ended) video.currentTime = 0;
        video.play().catch(() => {});
      }
      disconnectedCallback() {
        this.querySelector('video')?.pause();
        if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.previousOverflow ?? ''; }
        this.events?.abort();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
